module.exports = __webpack_public_path__ + "static/media/pic3.b8c125c4.jpg";